import { useAppContext } from '@mobile-mapping/providers';
import { Component } from 'solid-js';

import { LabeledSwitch } from './LabeledSwitch';

export const ExperimentToggle: Component<{ name: string }> = (props: {
  name: string;
}) => {
  const { experiments, setExperiments } = useAppContext();

  return (
    <LabeledSwitch
      label={props.name}
      value={experiments()[props.name] ?? false}
      onToggle={() =>
        setExperiments({
          ...experiments(),
          [props.name]: !(experiments()[props.name] ?? false),
        })
      }
    />
  );
};
